<template>
    <div class="container">
        <div class="pt-5">
            <h1 class="h3">Settings</h1>
            <div class="py-2">
             
                <settings-menu></settings-menu>
            </div>
            <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
            <h3 class="h3">Intergration settings</h3>
            <small>This page allows you to integrate Dukakit with other platforms </small>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="float-right">
                    <button @click="saveReportSettings()" class="btn btn-primary px-3">Save Changes</button>
                </div>
                </div>
                </div>
         
            <div class="container text-left mb-5">
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Your API Key </h6>
                        <small>
                           Some platforms will ask you for your Dukakit API Key. Copy the key and paste the key.
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        
                         <small v-if="userDetails.api_token">{{ userDetails.api_token }}</small>  
                        
                      <div class="btn-inline">
                        <a @click="generateToken" class="btn btn-sm btn-secondary">Generate new Key</a>
                        <!-- <a @click="agreeDelete" class="btn btn-sm btn-secondary">Delete Key</a> -->
                      </div> 
                    </div>
                  
                </div>
                
                
            </div>
        </div>
        
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
    export default {
        
        name: "profile",
        data() {
            return {
                companyDetails:{},
                apiToken:''
            }
        },
        computed:{
            ...mapGetters(['userDetails'])
        },
        mounted() {
            this.getUserCompanyDetails()
            
            
        },
        methods: {
            
            getUserCompanyDetails() {
              
              this.companyDetails = this.userDetails.company
              this.apiToken = this.userDetails.api_token
             },
             getApiTokens(){
                axios.get('/api/get-tokens',{params:{token:this.selectedkey}}).then(results=>{
                this.apikeys = results.data;
                })

            },
          
            agreeDelete()
            {
                axios.get('/api/delete-token',{params:{token_id:this.selectedkeyid}}).then(results=>{
                    this.$toasts.push({
                        type: "success",
                        message: "Token deleted successfully",


                    });
                });

                this.$refs['deletekey'].hide();
               
            },
            onCopy: function (e) {
                this.copyMessage = 'Copied...'
            this.$toasts.push({
                'type':'success',
                'message':'Copied successfully'
            })
            },
            onError: function (e) {
                this.$toasts.push({
                'type':'error',
                'message':'Failed to copy,retry'
            })
          
            },
            generateToken()
            {
                axios.get('/api/generate-token').then(results=>{
                    
                    this.$toasts.push({
                        type: "success",
                        message: "Token generated successfully",


                    });
                });
                location.reload()
            },
        
        },
    }
</script>

<style scoped>

</style>